export default __webpack_public_path__ + "static/media/test-assignment-zechmann-hero-de.6076de41.png";